(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-bubble_boostecom"] && !Shopify.designMode) return;
  try {
    (function(){
    const wrappers = document.querySelectorAll('.circle-slider-wrapper');
    wrappers.forEach((root)=>{
      const slider = root.querySelector('.circle-slider');
      if(!slider) return;
      if(slider.getAttribute('data-swipe') !== 'true') return;
      if(slider.dataset.initialized === '1') return;
      slider.dataset.initialized = '1';
      const align = slider.getAttribute('data-align') || 'center';
      const snap = slider.getAttribute('data-snap') === 'true';
      const infinite = slider.getAttribute('data-infinite') === 'true';
      const startIndex = parseInt(slider.getAttribute('data-start-index') || '0', 10);

      // Drag-to-scroll (desktop + mobile)
      let isDown=false, startX=0, scrollLeft=0;
      const onDown=(e)=>{ isDown=true; startX=(e.touches?e.touches[0].pageX:e.pageX); scrollLeft=slider.scrollLeft; slider.classList.add('is-dragging'); if(e && e.cancelable && e.type==='mousedown') e.preventDefault(); };
      const onMove=(e)=>{ if(!isDown) return; const x=(e.touches?e.touches[0].pageX:e.pageX); const walk=(startX-x); slider.scrollLeft=scrollLeft+walk; if(e && e.cancelable) e.preventDefault(); };
      const onUp=()=>{ isDown=false; slider.classList.remove('is-dragging'); };
      slider.addEventListener('mousedown', onDown); slider.addEventListener('mousemove', onMove); window.addEventListener('mouseup', onUp);
      slider.addEventListener('touchstart', onDown, {passive:false}); slider.addEventListener('touchmove', onMove, {passive:false}); slider.addEventListener('touchend', onUp);

      // Empêche le scroll horizontal de la page sur trackpads quand geste majoritairement horizontal
      slider.addEventListener('wheel', (e)=>{ try { if(Math.abs(e.deltaX) > Math.abs(e.deltaY)) { e.preventDefault(); slider.scrollLeft += e.deltaX; } } catch(_){} }, {passive:false});

      // Buttons prev/next
      const prevBtn = root.querySelector('.circle-nav-btn--prev');
      const nextBtn = root.querySelector('.circle-nav-btn--next');
      const autoHideNav = slider.getAttribute('data-auto-hide-nav') === 'true';
      const scrollStep = ()=>{
        const first = slider.querySelector('.circle-item');
        const style = getComputedStyle(slider);
        const gapVar = window.matchMedia('(max-width: 749px)').matches ? '--slider-gap-mobile' : '--slider-gap-desktop';
        const gap = parseInt(style.getPropertyValue(gapVar)) || 30;
        const w = first ? first.getBoundingClientRect().width : 120;
        return Math.round(w + gap);
      };
      const scrollBy = (dir)=>{ slider.scrollBy({left: dir*scrollStep(), behavior:'smooth'}); };
      prevBtn && prevBtn.addEventListener('click', ()=>scrollBy(-1));
      nextBtn && nextBtn.addEventListener('click', ()=>scrollBy(1));

      const updateNavVisibility = ()=>{
        if(!autoHideNav || !prevBtn || !nextBtn) return;
        const overflow = slider.scrollWidth > slider.clientWidth + 1;
        prevBtn.style.display = overflow ? '' : 'none';
        nextBtn.style.display = overflow ? '' : 'none';
      };
      updateNavVisibility();
      window.addEventListener('resize', updateNavVisibility);

      // Keyboard nav
      slider.addEventListener('keydown', (e)=>{
        if(e.key==='ArrowRight'){ e.preventDefault(); scrollBy(1); }
        if(e.key==='ArrowLeft'){ e.preventDefault(); scrollBy(-1); }
      });

      // Auto-center du produit actif au chargement + scroll-padding en center
      const active = slider.querySelector('.circle-item--active');
      const applyScrollPadding = ()=>{
        if(align !== 'center') { slider.style.scrollPadding = ''; slider.style.paddingLeft=''; slider.style.paddingRight=''; return; }
        const first = slider.querySelector('.circle-item');
        if(!first) return;
        const style = getComputedStyle(slider);
        const w = first.getBoundingClientRect().width;
        const edge = parseInt(slider.getAttribute('data-edge-offset') || '0', 10) || 0;
        const pad = Math.max(0, (slider.clientWidth - w) / 2 + edge);
        slider.style.scrollPadding = `0 ${pad}px`;
        slider.style.paddingLeft = `${pad}px`;
        slider.style.paddingRight = `${pad}px`;
      };
      applyScrollPadding();
      window.addEventListener('resize', applyScrollPadding);

      if(active){
        const sliderRect = slider.getBoundingClientRect();
        const itemRect = active.getBoundingClientRect();
        const current = slider.scrollLeft;
        const targetLeft = itemRect.left - sliderRect.left + current;
        let offset = 0;
        if(align === 'center'){
          offset = targetLeft - (sliderRect.width/2 - itemRect.width/2);
        } else {
          offset = targetLeft; // align left
        }
        slider.scrollTo({left: Math.max(0, offset), behavior: 'smooth'});
      } else if(!Number.isNaN(startIndex) && startIndex > 0){
        // Start index custom si pas d'item actif
        const items = Array.from(slider.querySelectorAll('.circle-item'));
        if(items.length){
          const idx = Math.min(startIndex, items.length - 1);
          const target = items[idx];
          const rectS = slider.getBoundingClientRect();
          const rectI = target.getBoundingClientRect();
          const current = slider.scrollLeft;
          const targetLeft = rectI.left - rectS.left + current;
          let offset = 0;
          if(align === 'center'){
            offset = targetLeft - (rectS.width/2 - rectI.width/2);
          } else {
            offset = targetLeft;
          }
          slider.scrollTo({left: Math.max(0, offset), behavior:'smooth'});
        }
      }

      // Snap strict: à la fin d'un drag, recaler exactement sur un item
      if(snap){
        const snapToNearest = ()=>{
          const items = Array.from(slider.querySelectorAll('.circle-item'));
          if(!items.length) return;
          const style = getComputedStyle(slider);
          const first = items[0];
          const w = first.getBoundingClientRect().width;
          const gapVar = window.matchMedia('(max-width: 749px)').matches ? '--slider-gap-mobile' : '--slider-gap-desktop';
          const gap = parseInt(style.getPropertyValue(gapVar)) || 30;
          const step = Math.round(w + gap);
          const padLeft = parseInt(style.paddingLeft) || 0;
          const x = Math.max(0, slider.scrollLeft - padLeft);
          const idx = Math.round(x / step);
          const target = idx * step + padLeft;
          slider.scrollTo({left: target, behavior:'smooth'});
        };
        slider.addEventListener('mouseup', snapToNearest);
        slider.addEventListener('touchend', snapToNearest);
        slider.addEventListener('keyup', (e)=>{ if(e.key==='ArrowLeft'||e.key==='ArrowRight') snapToNearest(); });
      }

      // Bouclage infini (virtuel) en dupliquant visuellement le premier et le dernier step
      if(infinite){
        const normalize = ()=>{
          const style = getComputedStyle(slider);
          const first = slider.querySelector('.circle-item');
          if(!first) return;
          const w = first.getBoundingClientRect().width;
          const gapVar = window.matchMedia('(max-width: 749px)').matches ? '--slider-gap-mobile' : '--slider-gap-desktop';
          const gap = parseInt(style.getPropertyValue(gapVar)) || 30;
          const step = Math.round(w + gap);
          const count = slider.querySelectorAll('.circle-item').length;
          if(count < 2) return;
          const total = step * count;
          const padLeft = parseInt(style.paddingLeft) || 0;
          let x = Math.max(0, slider.scrollLeft - padLeft);
          if(x <= 0){ x = total - step*2; }
          else if(x >= total - step){ x = step; }
          slider.scrollLeft = x + padLeft;
        };
        slider.addEventListener('scroll', ()=>{ if(!snap) return; window.requestAnimationFrame(normalize); });
        // Premier alignement pour créer un tampon si nécessaire
        setTimeout(()=>{
          const style = getComputedStyle(slider);
          const first = slider.querySelector('.circle-item');
          if(!first) return;
          const w = first.getBoundingClientRect().width;
          const gapVar = window.matchMedia('(max-width: 749px)').matches ? '--slider-gap-mobile' : '--slider-gap-desktop';
          const gap = parseInt(style.getPropertyValue(gapVar)) || 30;
          const step = Math.round(w + gap);
          const padLeft = parseInt(style.paddingLeft) || 0;
          slider.scrollLeft = step + padLeft; // décalage initial pour permettre le wrap à gauche
        }, 50);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
